import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '../../lib/utils';
interface LogoProps {
  className?: string;
  inverted?: boolean;
  size?: 'sm' | 'lg';
}
export function Logo({
  className,
  inverted = false,
  size = 'sm'
}: LogoProps) {
  const monogram = size === 'lg' ? 'text-6xl md:text-7xl' : 'text-[36px] md:text-[42px]';
  const script = size === 'lg' ? 'text-4xl md:text-5xl' : 'text-2xl md:text-[26px]';
  return <Link to="/" aria-label="L.A Property Law and Conveyancing, home" className={cn('group inline-block leading-none', className)} data-id="element-497">
      {/* Relative box sized by an invisible in-flow copy of the wider (script) word */}
      <span className="relative inline-flex items-center justify-center" data-id="element-498">
        {/* sizer: invisible, defines the box width/height to the script word */}
        <span className={cn('font-script invisible whitespace-nowrap px-1', script)} data-id="element-499">
          conveyancing
        </span>

        {/* Charcoal serif LA monogram, centred behind */}
        <span className={cn('font-serif tracking-[0.06em] absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transition-colors', monogram, inverted ? 'text-cream' : 'text-ink')} aria-hidden="true" data-id="element-500">
          LA
        </span>

        {/* Cobalt handwritten script across the centre */}
        <span className={cn('font-script absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap leading-none transition-colors', script, inverted ? 'text-brand-blue-light' : 'text-brand-blue')} aria-hidden="true" data-id="element-501">
          conveyancing
        </span>
      </span>
    </Link>;
}